import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { OwnerPageComponent } from './owner.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: OwnerPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class OwnerPageRoutingModule {}
